'use strict';

import controller from './datos-asociacion.controller';
import template from './datos-asociacion.html';

const DatosAsociacionComponent = {
  bindings: {
    empresa: '=',
    asociacion: '='
  },
  controller,
  template
};

export default DatosAsociacionComponent;



// WEBPACK FOOTER //
// ./src/app/components/empresas/c-empresas/datos-asociacion/datos-asociacion.component.js